<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
	export default {
		onLaunch: function() {
			
		},
		
		onShow: function() {
			//console.log('App Show')
		},
		
		onHide: function() {
			//console.log('App Hide')
		}
	}
</script>

<style lang="scss">
	/* #ifdef APP-PLUS */
		@import '@/uni_modules/uv-ui-tools/index.scss';
	/* #endif */
	
	@import '@/static/css/base.css';
	@import '@/static/css/style.css';
	@import '@/static/iconfonts/iconfont.css';
</style>